<template>
  <div class="modal-card">
    <b-icon
      icon="check-circle-outline"
      :type="isContrast ? 'is-white' : 'is-green-lawn'"
      class="my-35"
      customSize="mdi-80px"
      size="is-large"
    />
    <div class="mb-35 mt-25 has-text-centered has-text-weight-semibold">
      <span>{{ message }}:</span>
      <br /><span class="has-text-weight-normal">
        {{ name.toUpperCase() }}</span
      >
    </div>
    <div class="button-wrapper">
      <b-button
        expanded
        :label="General.OK.toUpperCase()"
        :type="isContrast ? 'is-white' : 'is-green-lawn'"
        class="has-text-weight-semibold"
        @click="close"
      ></b-button>
    </div>
  </div>
</template>

<script>
import { General, App } from "@/utils/constants";
import { mapGetters } from "vuex";

export default {
  name: "ModalGenericConfirmation",
  props: {
    name: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      General,
      App
    };
  },
  computed: {
    ...mapGetters({ isContrast: "isContrast" })
  },
  methods: {
    close() {
      this.$parent.close();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";
.modal-card {
  display: flex;
  align-items: center;
  padding: 25px 35px;
  max-height: 75vh;
  background-color: $color-1;
  color: $color-7;

  .button-wrapper {
    min-width: 150px;
  }
}
</style>
